export const SET_LOADING = 'APPLICATION/SET_LOADING';
export const SET_SERVICES = 'APPLICATION/SET_SERVICES';
export const SET_EVENTS = 'APPLICATION/SET_EVENTS';
export const SET_MENUS = 'APPLICATION/SET_MENUS';
export const SET_OPEN_MENU = 'APPLICATION/SET_OPEN_MENU';
export const SET_DEFAULT_ROUTER = 'APPLICATION/SET_DEFAULT_ROUTER';
export const SET_TOGGLE_MENU = 'APPLICATION/SET_TOGGLE_MENU';
export const SET_SHOW_NOTIFICATIONS = 'APPLICATION/SET_SHOW_NOTIFICATIONS';
export const SET_USER_COLLECTION = 'APPLICATION/SET_USER_COLLECTION';
